import React, { Component, Fragment } from 'react';
import axios from 'axios';
import ReactTooltip from 'react-tooltip'

import {reqData, stickStr, buttonStr, attackStr, flowStr} from './utils'
import MotEntryTable from './MotEntryTable'
import MotEntryDetail from './MotEntryDetail'
import CancelTable from './CancelTable'
import tooltips from './tooltips'

class App extends Component {
  state = {
    characters:[],
    loadedCharacter:'',
    data:null,
    selectedMotId:null,
    selectedMot:null,
    options:{
      hideItemMoves: true,
      hideBackSideMoves: true
    }
  }
  componentDidMount() {
    axios.get(`/json/characters.json`)
      .then(res => {
        const characters = res.data;
        this.setState({ characters });
        this.change(this.props.routeInfo.params.character || 'ann', parseInt(this.props.routeInfo.params.mot,16) || 0x8001)

      })
      this.props.history.listen(location => {
        if(!location.state){
          return;
        }
        this.change(location.state.loadedCharacter, location.state.motId)
      })
  }
  change(character,motId){
    if(character != this.state.loadedCharacter){
      this.loadCharacter(character).then(() =>{
        this.changeMot(motId)
      });
    } else{
      this.changeMot(motId)
    }
  }
  changeMot(selectedMotId){
    var urlId = selectedMotId;
    if(selectedMotId > 0x7fff){
      selectedMotId = this.state.data.aliases[selectedMotId]
    }
    var selectedMot = this.state.data.states[selectedMotId];
    document.title = `T7Matrix :: ${this.state.loadedCharacter} :: ${urlId.toString(16)} ${selectedMot.name}`;
    this.setState({ selectedMot,selectedMotId });
  }
  loadCharacter(character){
    var data = null;
    var loadedCharacter = '';
    this.setState({ data,loadedCharacter });
    return axios.get(`/json/${character}mot.bin.json`)
      .then(res => {
        const data = res.data;
        const loadedCharacter = character;
        this.setState({ data,loadedCharacter });
      })
  }
  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    var options = this.state.options;
    options[name] = value;
    this.setState({options});
  }
  handleChangeCharacter = (event) => {
    this.props.history.push("/browser/"+event.target.value+"/8001",
      {loadedCharacter:event.target.value, motId:0x8001}
    );
  }
  handleChangeMot = (urlId) => {
    this.props.history.push("/browser/"+this.state.loadedCharacter+"/"+urlId.toString(16),
      {loadedCharacter:this.state.loadedCharacter, motId:urlId}
    );
    return false
  }

  render() {
    var {characters,loadedCharacter,data, selectedMot,selectedMotId,options} = this.state;
    var image = null;
    if(loadedCharacter){
      console.log(loadedCharacter)
      var t = loadedCharacter.toUpperCase();
      var imgPath = loadedCharacter;
      if(['kum','pan'].includes(loadedCharacter)) imgPath += "_"+Math.floor((Math.random() * 2)+1);
      image = <img className="charaImg" src={"/img/CS_CH_PANEL_"+imgPath.toUpperCase()+".png"} />
    }
    return (
      <div className="App">
        <ReactTooltip />
        <div className="header">
          {image}
          <div className="note">
            Note: this particular data is created directly from data, not from in-engine gameplay.
            This means it can and will be wrong in many cases. If you see an area you think is incorrect, let
            @dantarion know and it will be fixed..at some point?<br /><br />
          <strong>TODO: CrushFlags, Frameadvantage, Tooltips, "what cancels into this?", ComboTool</strong>
          </div>
          <h1>T7Matrix by @dantarion</h1>
          <div className="options">
            <div  className="optionsBox u-pull-left">
                <label >Select Character:</label>
                <select value={loadedCharacter}   onChange={this.handleChangeCharacter}>
                    <option key={-1}></option>
                    {characters.map((character,i) => <option key={i} value={character[1]}>{character[0]} ({character[1].toUpperCase()})</option>)}
                </select>
            </div>
            <div className="optionsBox u-pull-left">

                <label >Additional Options....</label>
                <div>
                    <input name="hideItemMoves" checked={options.hideItemMoves} onChange={this.handleInputChange} type="checkbox" /> Hide Item Moves <i data-tip={tooltips.hideItemMoves} className="fas fa-question-circle tip"></i>
                    <input name="hideBackSideMoves" checked={options.hideBackSideMoves} onChange={this.handleInputChange} type="checkbox" /> Hide Back/Side Moves <i data-tip={tooltips.hideBackSideMoves} className="fas fa-question-circle tip"></i>
                </div>

            </div>


              <div className="u-cf"></div>
          </div>
        </div>
        <div className="content">
          <div className="three columns left">
            <MotEntryTable {...this.state} selectMot={this.handleChangeMot}/>
          </div>
          <div className="three columns middle">
            <MotEntryDetail {...this.state} selectMot={this.handleChangeMot}/>
          </div>
          <div className="six columns right">
            <CancelTable {...this.state} selectMot={this.handleChangeMot} startIndex={selectedMot && selectedMot.cancelId} />
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js